export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML检查"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入地址并选择区块链——我们将进行快速筛查。"])}
}